import React, { useState } from 'react'
import {
  Alert,
  Button,
  Text,
  constants,
  PaymentInstructionsModal,
  useApplicationContext,
} from '@adc/ui-adc'
import { wallet } from '@adc/blueprint'
import classnames from 'classnames/bind'
import { useListingContext } from 'common/context/listing'
import { isPendingFclOnlineDeposit } from 'common/utils/listing'
import styles from './styles.scss'

const cx = classnames.bind(styles)
const { ColorNames } = constants

interface CompleteRegistrationDepositBannerProps {
  inline?: boolean
}

const customTitle = 'Complete Registration Deposit'

export const CompleteRegistrationDepositBanner = ({
  inline = false,
}: CompleteRegistrationDepositBannerProps) => {
  const { listing } = useListingContext()
  const { user, featureFlags } = useApplicationContext()

  const [open, setOpen] = useState(false)

  const renderContent = () => (
    <Text size='tiny' color='caution'>
      The deposit is not a fee, if you do not win it can be refunded.
    </Text>
  )

  const renderButton = () => (
    <Button
      className={cx('button')}
      data-elm-id='get_wire_instructions_button'
      tag='a'
      onClick={() => setOpen(true)}
      target='_blank'
      rel='noreferrer'
      role='auxiliary'
      color={ColorNames.Caution}
    >
      Get Funding Instructions
    </Button>
  )

  const depositAmount =
    listing.current_user_bid_deposit_requirements?.absolute_amount_required || 0

  if (!isPendingFclOnlineDeposit(listing, featureFlags)) {
    return null
  }

  return (
    <div className={cx('container')}>
      {inline ? (
        <Alert
          className={cx('alert')}
          role='caution'
          header={customTitle}
          content={renderContent()}
          slots={{
            action: () => renderButton(),
          }}
        />
      ) : (
        <Alert
          className={cx('alert')}
          role='caution'
          header={customTitle}
          content={
            <div className={cx('content')}>
              {renderContent()}
              {renderButton()}
            </div>
          }
        />
      )}
      <PaymentInstructionsModal
        open={open}
        onClose={() => setOpen(false)}
        depositAmount={depositAmount}
        bidderId={(user.logged_in && user.party_id) || ''}
        onDownload={() => {
          if (user.logged_in && user.party_id)
            wallet.utils.downloadForeclosureOnlinePaymentInstruction(
              user.party_id
            )
        }}
      />
    </div>
  )
}
